"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavSlide = void 0;
var hooks_1 = require("preact/hooks");
var navigation_1 = require("../utils/navigation");
var useNavSlide = function () {
    var _a = (0, hooks_1.useState)(false), open = _a[0], setOpen = _a[1];
    // Function to open slider
    var handleSlide = (0, hooks_1.useCallback)((0, navigation_1.handleSlideHOF)(setOpen), []);
    return {
        open: open,
        handleSlide: handleSlide,
    };
};
exports.useNavSlide = useNavSlide;
